<template>
  <form-section
    :title="$t('CampaignReport_BasicSettings')"
    :description="$t('CampaignReport_BasicSettings_Description')"
  >
    <form-item
      prop="title"
      :rules="rules"
      :label="$t('CampaignReport_BasicSettings_Name')"
    >
      <el-input style="width: 300px;" v-model="model.title" />
    </form-item>
  </form-section>
</template>
<script>
import FormItem from '@/common/components/form/FormItem.vue'
import FormSection from '@/common/components/form/FormSection.vue'

export default {
  name: 'BasicDetails',

  components: { FormSection, FormItem },

  data() {
    return {
      rules: [
        {
          required: true,
          message: this.$t('RestForm_FieldIsRequired'),
          trigger: 'blur'
        }
      ]
    }
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/report/BasicDetails.vue